import React, {lazy, Suspense} from 'react'
import { 
  createBrowserRouter,
   RouterProvider,
   Route, 
   createRoutesFromElements
  } from "react-router";
import HomePage from "./pages/HomePage";
const  Careers = lazy(()=>import('./pages/Careers'));
const  ContactPage = lazy(()=>import('./pages/ContactPage'));
const  ServicesPage = lazy(()=>import('./pages/ServicesPage'));
const  ServicesMorePage = lazy(()=>import('./pages/ServicesMorePage'));
const  RequestQuote = lazy(()=>import('./pages/RequestQuote'));
const  NotFound = lazy(()=>import('./pages/NotFound'));

const router = createBrowserRouter(createRoutesFromElements(
  <Route>
    <Route index element={<HomePage />} />
    <Route path="careers" element={<Careers />} />
    <Route path="contact" element={<ContactPage />} />
    <Route path="services" element={<ServicesPage />} />
    <Route path="services/:serviceId" element={<ServicesMorePage />} />
    <Route path="request-quote" element={<RequestQuote />} />
    <Route path="*" element={<NotFound />} />
  </Route>
))
// Modern Loading Spinner Component
function ModernLoadingSpinner() {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-gray-50 via-green-50 to-emerald-50 flex items-center justify-center z-50">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 100 100">
          <defs>
            <pattern id="loadingPattern" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <circle cx="10" cy="10" r="1" fill="currentColor" className="text-green-400"/>
              <rect x="8" y="8" width="4" height="4" fill="none" stroke="currentColor" className="text-emerald-300"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#loadingPattern)"/>
        </svg>
      </div>

      <div className="relative z-10 flex flex-col items-center">
        {/* Main Spinner Container */}
        <div className="relative mb-8">
          {/* Outer Ring */}
          <div className="w-20 h-20 rounded-full border-4 border-gray-200"></div>
          
          {/* Animated Ring */}
          <div className="absolute inset-0 w-20 h-20 rounded-full border-4 border-transparent border-t-green-600 border-r-emerald-500 animate-spin"></div>
          
          {/* Inner Pulsing Dot */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-3 h-3 bg-gradient-to-r from-green-600 to-emerald-600 rounded-full animate-pulse shadow-lg"></div>
          </div>
          
          {/* Orbiting Dots */}
          <div className="absolute inset-0 animate-spin" style={{animationDuration: '3s', animationDirection: 'reverse'}}>
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-bounce"></div>
            </div>
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1">
              <div className="w-2 h-2 bg-emerald-500 rounded-full animate-bounce" style={{animationDelay: '0.5s'}}></div>
            </div>
          </div>
        </div>

        {/* Loading Text */}
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-2 font-comfortaa">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-600">
              Arieri's World
            </span>
          </h2>
          <p className="text-gray-600 mb-4">Transforming challenges into opportunities...</p>
          
          {/* Progress Dots */}
          <div className="flex items-center justify-center space-x-2">
            <div className="w-2 h-2 bg-green-600 rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-green-600 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
            <div className="w-2 h-2 bg-green-600 rounded-full animate-bounce" style={{animationDelay: '0.4s'}}></div>
          </div>
        </div>

        {/* Brand Elements */}
        <div className="absolute bottom-8 flex items-center gap-2 text-gray-500">
          <div className="w-6 h-6 bg-gradient-to-r from-green-600 to-emerald-600 rounded-lg flex items-center justify-center">
            <div className="w-2 h-2 bg-white rounded-full"></div>
          </div>
          <span className="text-sm font-semibold tracking-wide">Arieri's World</span>
        </div>
      </div>
    </div>
  )
}

function App() {
  return (
    <div className="font-comfortaa scroll-smooth no-scrollbar ">
      <Suspense fallback={<ModernLoadingSpinner />}>
        <RouterProvider router={router} />
      </Suspense>      
    </div>
  );
}

export default App;
